module.exports = __webpack_public_path__ + "img/sprite.8ccce0fa.svg";